<template>
    <CardPage :section="9" :page="page" :nextDisabled="nextDisabled">
        <v-fade-transition hide-on-leave>
            <div v-if="!answered">
                <p class="subheading primary--text font-weight-bold text-xs-center">
                    {{ text }}
                </p>
                <v-container fluid grid-list-xs>
                    <v-layout row wrap align-center justify-space-around mx-3>
                        <v-flex xs4>
                            <v-btn round large color="primary" block @click="click('true')">True</v-btn>
                        </v-flex>
                        <v-flex xs4>
                            <v-btn round large color="primary" block @click="click('false')">False</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </v-fade-transition>
        <v-fade-transition hide-on-leave>
            <div v-if="answered">
                <v-container fluid grid-list-xs>
                    <v-layout row wrap align-center mx-3>
                        <v-spacer></v-spacer>
                        <v-flex xs5>
                            <v-container
                                fill-height
                                class="text-xs-center font-weight-bold white--text block-button"
                                :class="{ success: isCorrect, error: !isCorrect }"
                            >
                                <v-layout row wrap align-center>
                                    <v-flex>
                                        <v-icon dark v-if="isCorrect">thumb_up</v-icon>
                                        <v-icon dark v-else>thumb_down</v-icon>
                                        <div class="text-capitalize">{{ correctAnswer }}</div>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>
                </v-container>
                <slot></slot>
            </div>
        </v-fade-transition>
        <template v-if="!answered" v-slot:actions>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
export default {
    data() {
        return {
            answered: false
        };
    },
    props: {
        page: {
            type: Number,
            required: true
        },
        statement: {
            type: Number,
            required: true
        }
    },
    computed: {
        text() {
            return this.$store.get(`section9/statements@${this.statement}.text`);
        },
        correctAnswer() {
            return this.$store.get(`section9/statements@${this.statement}.correctAnswer`);
        },
        isCorrect() {
            return this.$store.get(`section9/statements@${this.statement}.correctAnswer`) === this.$store.get(`section9/statements@${this.statement}.answer`);
        }
    },
    methods: {
        click(response) {
            this.$store.set(`section9/statements@${this.statement}.answer`, response);
            this.answered = true;
        },
        nextDisabled() {
            return !this.answered;
        }
    }
};
</script>
